<template>
  <img
    v-if="lazyload"
    :data-src="imageSrc"
    alt="Logo"
    class="v-mid lazyload"
    :style="`width: ${setLogoWidth}`"
  />
  <img v-else :src="imageSrc" alt="Logo" class="v-mid" :style="`width: ${setLogoWidth}`" />
</template>

<script>
import logoFizeaustraat from "../../assets/logo-hotelv-fizeaustraat.svg"
import logoNesplein from "../../assets/logo-hotelv-nesplein.svg"
import logoFrederiksplein from "../../assets/logo-hotelv-frederiksplein.svg"
import logoPortal from "../../assets/logo-hotelv-thelobby.svg"
import logoPortalLight from "../../assets/logo-hotelv-thelobby-light.svg"
import logoLobbyFizeaustraat from "../../assets/logo-the-lobby-fizeaustraat.svg"
import logoLobbyNesplein from "../../assets/logo-the-lobby-nesplein.svg"
import logoFizeaustraatDark from "../../assets/logo-hotelv-fizeaustraat--dark.svg"
import logoNespleinDark from "../../assets/logo-hotelv-nesplein--dark.svg"
import logoFrederikspleinDark from "../../assets/logo-hotelv-frederiksplein--dark.svg"
import logoLobbyFizeaustraatDark from "../../assets/logo-the-lobby-fizeaustraat--dark.svg"
import logoLobbyNespleinDark from "../../assets/logo-the-lobby-nesplein--dark.svg"
import s from "../store"

export default {
  name: "Logo",

  props: {
    logoKey: String,
    logoWidth: {
      type: String,
      default: "100px"
    },
    lazyload: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      sharedState: s.state
    }
  },

  mounted() {},

  computed: {
    imageSrc: function() {
      switch (this.logoKey) {
        case "hotelVFizeaustraat":
          return logoFizeaustraat
        case "hotelVNesplein":
          return logoNesplein
        case "hotelVFrederiksplein":
          return logoFrederiksplein
        case "theLobbyFizeaustraat":
          return logoLobbyFizeaustraat
        case "theLobbyNesplein":
          return logoLobbyNesplein
        case "hotelVDark":
          return logoPortal
        case "theLobbyDark":
          return logoPortal
        case "hotelV":
          return logoPortalLight
        case "theLobby":
          return logoPortalLight
        case "theLobbyNespleinDark":
          return logoLobbyNespleinDark
        case "theLobbyFizeaustraatDark":
          return logoLobbyFizeaustraatDark
        case "hotelVFrederikspleinDark":
          return logoFrederikspleinDark
        case "hotelVNespleinDark":
          return logoNespleinDark
        case "hotelVFizeaustraatDark":
          return logoFizeaustraatDark
        case "webshop":
          return logoPortalLight
        case "webshopDark":
          return logoPortal
      }
    },
    setLogoWidth: function() {
      return this.logoWidth
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* img {
  width: 100px;
} */
</style>
